<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';
// NOTICE: KAPTION-INTEGRATION - rumo-actions.PROTOCOL.1: offered buttons, read-only
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';
import KaptionOfferedOptions from './KaptionOfferedOptions.vue';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();
// NOTICE: KAPTION-INTEGRATION - rumo-actions.PROTOCOL.1
const { isKaptionFlagEnabled } = useKaptionFeatureFlags();
const kaptionOfferedOptions = computed(() => {
  if (contentType.value !== CONTENT_TYPES.INPUT_SELECT) return null;
  if (!isKaptionFlagEnabled('KAPTION_RUMO_ACTIONS')) return null;
  const items = contentAttributes.value?.items ?? [];
  if (!items.length) return null;
  const [chosen] = contentAttributes.value?.submittedValues ?? [];
  return {
    items,
    suggestions: contentAttributes.value?.kaptionSuggestions ?? [],
    chosenValue: chosen?.value ?? null,
  };
});

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span v-dompurify-html="content" :title="content" />
    <!-- NOTICE: KAPTION-INTEGRATION - rumo-actions.PROTOCOL.1 -->
    <KaptionOfferedOptions
      v-if="kaptionOfferedOptions"
      v-bind="kaptionOfferedOptions"
    />
    <dl v-else-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="text-n-slate-11 italic mt-2">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd>{{ item.title }}</dd>
      </template>
    </dl>
    <div v-else-if="isAWebWidgetInbox" class="my-2 font-medium">
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>
  </BaseBubble>
</template>
